import { FC } from "react";
import styles from "./styles.module.css";

interface ErrorBlockProps {
  error: string | null | undefined;
  className?: string;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({ error, className }) => {
  if (!error) return null;

  return (
    <div className={`${styles.errorBlock} ${className ?? ""}`}>
      <span className={styles.icon}>!</span>
      <span className={styles.message}>{error}</span>
    </div>
  );
};
